import cloneDeep from 'lodash/cloneDeep';
import Vue from 'vue';

// The interest, favourite and owner lookups are not awaited, so their answers
// can land after the user opened another ad (KL-1G, KL-W). Merged into the
// cleared {} they produced an "ad" with no propositionId or residences.
function isShownProposition(state, propositionId) {
  const shownId = state.currentProposition?.propositionId;
  return (
    shownId !== undefined &&
    shownId !== null &&
    String(shownId) === String(propositionId)
  );
}

function setPropositionUser(state, { user }) {
  const current = state.currentProposition;
  if (!current?.propositionId) return;
  if (user?.userId && current.userId && user.userId !== current.userId) return;

  Vue.set(current, 'user', user);
}

function setCurrentProposition(state, { proposition, residenceIndex }) {
  state.currentResidenceIndex = residenceIndex;
  state.currentProposition = proposition;
  state.baseLoading = false;
}

function mapExtrasToProposition(state, { views, user }) {
  const currentPropositionCopy = cloneDeep(state.currentProposition);

  currentPropositionCopy.totalVisits = views.toString();
  currentPropositionCopy.user = user;

  state.currentProposition = currentPropositionCopy;
}

function mapAmenitiesDataToProposition(state, { hittaData }) {
  const currentPropositionCopy = { ...state.currentProposition };

  hittaData.amenities.residences.forEach((data, index) => {
    currentPropositionCopy.residences[index] = {
      ...currentPropositionCopy.residences[index],
      amenities: data
    };
  });

  state.currentProposition = currentPropositionCopy;

  state.hittaLoading = false;
}

function mapFavouriteDataToProposition(
  state,
  { favouriteData, propositionId }
) {
  if (!isShownProposition(state, propositionId)) return;

  const currentPropositionCopy = { ...state.currentProposition };

  currentPropositionCopy.favourite = favouriteData;

  state.currentProposition = currentPropositionCopy;
}

function hittaFailed(state) {
  state.hittaLoading = false;
}

function mapInterestDataToProposition(state, { interestData, propositionId }) {
  if (!isShownProposition(state, propositionId)) return;

  const currentPropositionCopy = { ...state.currentProposition };

  const updatedCurrentPropositionCopy = {
    ...currentPropositionCopy,
    ...interestData
  };

  state.currentProposition = updatedCurrentPropositionCopy;
  state.interestDataLoading = false;
}

function stopInterestLoading(state) {
  state.interestDataLoading = false;
}

function noNeedForExtrasLoading(state) {
  state.hittaLoading = false;
  state.interestDataLoading = false;
}

function setIsLoading(state) {
  state.baseLoading = true;
  state.hittaLoading = true;
  state.interestDataLoading = true;
  state.loadingFailed = false;
}

function setLoadingFailed(state) {
  state.baseLoading = false;
  state.loadingFailed = true;
}

function setSponsoredPropositions(state, { sponsored }) {
  state.sponsoredPropositions = sponsored;
}

function setCurrentResidence(state, { index }) {
  state.currentResidenceIndex = index;
}

function setSwapInterest(state, { targetPropositionId, interested }) {
  if (!state.currentProposition || !state.currentProposition.propositionId) {
    return;
  }

  if (
    targetPropositionId.toString() ===
    state.currentProposition.propositionId.toString()
  ) {
    state.currentProposition.interested = interested;
  }
}

function clearCurrentProposition(state) {
  state.currentProposition = {};
}

function setCurrentFavourite(state, { favourite }) {
  const currentPropositionCopy = { ...state.currentProposition };

  currentPropositionCopy.favourite = favourite;

  state.currentProposition = currentPropositionCopy;
}

function setPropositionsSiteCount(state, propositionsSiteCount) {
  state.propositionsSiteCount = propositionsSiteCount;
}

export default {
  setPropositionUser,
  setCurrentProposition,
  mapExtrasToProposition,
  setIsLoading,
  setLoadingFailed,
  setSponsoredPropositions,
  setCurrentResidence,
  setSwapInterest,
  clearCurrentProposition,
  noNeedForExtrasLoading,
  mapAmenitiesDataToProposition,
  hittaFailed,
  mapInterestDataToProposition,
  stopInterestLoading,
  setCurrentFavourite,
  mapFavouriteDataToProposition,
  setPropositionsSiteCount
};
